/**
 * Formats a number to a string with a given number of decimal places
 * and appends the UOM to the end of the string (" or mm)
 * @return {string}
 */
export const formatNumberToUOMString = (value: number, isMetric = false, digits = 3, hideUnits = false): string => {
  return isMetric
    ? (value || 0).toFixed(digits) + (hideUnits ? '' : 'mm')
    : (value || 0).toFixed(digits) + (hideUnits ? '' : '"');
};